import './arrowBullet.scss';

import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ArrowBullet = () => {
  return (
    <div className='arrow-bullet'>
      <FontAwesomeIcon icon={faArrowRight} className='arrow-bullet__icon' />
    </div>
  );
};

export default ArrowBullet;
